// extracted by mini-css-extract-plugin
module.exports = {"root":"DocumentationNav-module--root--4gn1d","link":"DocumentationNav-module--link--3REe7","current":"DocumentationNav-module--current--p3AmO"};